export default "__VITE_ASSET__BHA3OFLy__"